export interface IUser {
  selectTypeGrid?: number;
  username?: string;
  language_id?: number;
  email?: string;
  countryID?: number | null;
  baseID?: number; // user preference to show base on its own column
  rememberLogin?: boolean;
  tosAgree?: boolean;
  password?: string,
  autoUpdate?: boolean;
  languageID?: number;
  archivedReport?: ArchivedReport;
  mergedRows?: MergedRows;
  customerName?: string;
  Customer?: Customer;
  groupID?: number;
  groupShortLabel?: string;
  groupLabel?: string;
  classID?: number;
  classLabel?: string;
  subgroupID?: null;
  variableComboID?: number;
  tosURL?: string;
  helpURL?: string;
}
export interface IAudience {
  CodErro?: number;
  MsgErro?: string;
  DateRating?: string;
  ListDadosRating?: string;
}
export interface IContext extends IUser {
  authenticate: (username: string, password: string, countyId: number, language: string, rememberLogin: boolean, tosAgree: boolean) => Promise<any>;
  logout: () => void;
  setUserAuth: (user: IUser) => void;
  IsAuthenticated: () => boolean;
  handleDisconnectedUser: (data: any, userIsAuthenticated: boolean) => void;
  isAutoLoginLoading?: boolean;
}
export interface IAuthProvider {
  children: JSX.Element;
}
export interface IUserPreferenceDataRequest {
  userPreference?: any;
  idLanguage?: string | null;
  praca?: IPraca | null;
  pracaEquivalente?: number | null;
  urlImg?: string | null;
  autoUpdate?: boolean | null;
  tipoBase?: number | null;
  data?: string | null;
  hora?: string | null;
  horaIni?: string | null;
  target?: number | null;
  indice?: number | null;
  periodo?: number | null;
  ordem?: number | null;
}
export interface IUserDataRequest {
  UserUserAutoScroll: boolean,
  Data: string,
  HorarioIni: string,
  Horario: string,
  Language: { Id: number },
  Periodicidade: { Id: number },
  Praca: {
    Id: number,
    Desc: string,
    Abrev: string
  },
  Target: { Id: number },
  Indice: number,
  Ordenacao: number,
  Country: { CountryID: number },
  PracaImagem: {},
  ChangeAutoUpdate: boolean,
  TipoBase: number
}
export interface IChannelData {
  id: number;
  label: string;
  seq: number;
  thumbnails: string;
  isTotal: boolean;
  color: string;
  icons: IChannelDataIcons;
}
export interface IChannelDataResponse {
  error: any;
  enabled: IChannelData[];
  disabled: IChannelData[];
  selected: any;
}
export interface IChannelDataIcons {
  menu: string;
  menuBitmap: string;
  table: string;
  tableBitmap: boolean;
}
export interface SetChangePassword {
  CurrentPassword: string;
  NewPassword: string;
  NewConfirmPassword: string;
}
export enum ChannelDataOrder {
  BySeq = 0,
  ByLabel = 1
}

export interface ArchivedReport {
  date: string;
  start: string;
  end: string;
}
export interface MergedRows {
  frequencyID: number;
  mergeFunctionID: number;
}

export interface IDateTimeAudienceCountry {
  HoraFim: string;
  HoraIni: string;
}

export interface Customer {
  Name: string;
}
export interface SetChangePassword {
  CurrentPassword: string;
  NewPassword: string;
  NewConfirmPassword: string;
}
export interface IPraca {
  Id: number;
  Desc: string;
  UrlImg: string | null;
  PracaEquivalente: number;
  GMT: number;
  QtdeEmissoras: number;
  QtdeSubPracas: number;
  Abrev: string;
  GravaImagem: boolean;
  ImgPath: string;
  RealTime: boolean;
  Targets: ITarget | null;
}

export interface ITarget {
  Id: number;
  Desc?: string; 
  FatorCor?: string;
  FatorDesc?: string; 
  [key: string]: any;
}

export interface IMediaC {
  indice?: string;
  codIndice?: number;
  data?: string;
  minutos?: string;
  autoUpdate?: boolean;
}